import { Record } from 'immutable';

import { State } from './types';

export const stateFactory = Record<State>({
  completeWizardProps: undefined,
  initialized: false,
});
